import { Debtor } from "../types/Debtor";
import { Balance } from "../types/Balance";
import { ApiService } from "./ApiService";
import { Company } from "../types/Company";

const baseUrl = "/services/rateagreement/api/debt/";

class DebtService extends ApiService {
    async getBalance(debtNumber: string): Promise<Balance> {
        const response = await fetch(baseUrl + debtNumber + "/balance", {
            method: "GET",
            headers: {
                Accept: "application/json",
            },
        });
        const balanceResponse = await this.handleResponse(response);
        return balanceResponse.json();
    }

    async getDebtor(debtNumber: string): Promise<Debtor> {
        const response = await fetch(baseUrl + debtNumber + "/debtor", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const debtorResponse = await this.handleResponse(response);
        return debtorResponse.json();
    }

    async getCompany(debtNumber: string): Promise<Company> {
        const response = await fetch(baseUrl + debtNumber + "/company", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });

        const result = await this.handleResponse(response);
        return result.json();
    }
}

export default new DebtService();
